import { createSlice } from '@reduxjs/toolkit'; 

export interface ZipCodeInitialState {
  selectedZipCode: string;
  loading: boolean;
  error: string;
  success: boolean;
}

const initialState: ZipCodeInitialState = {
  selectedZipCode: '',
  loading: false,
  error: '',
  success: false,
};

export const ZipCodeSlice = createSlice({
  name: 'zipCodeSlice',
  initialState,
  reducers: {
    setSelectedZipCode: (state, action) => {
      state.selectedZipCode = action.payload;
    },
  },
});

export const ZipCodeActions = {
  ...ZipCodeSlice.actions,
};

export const ZipCodeReducer = ZipCodeSlice.reducer;
